<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <table-edit :cols="columnDefinitions" :rows="records"></table-edit>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row" v-for="(v, k) in columnDefinitions" :key="k">
        <label :for="safeId(k)" class="col-sm-4 col-form-label">{{ v }}</label>
        <div class="col-sm-8">
          <column-select :id="safeId(k)" :value="columnMap[k]" @input="val => {
            columnMap[k] = val
            columnMap = columnMap
          }" :dataset-id="datasetId"></column-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapOverlayOptions, mapTemplateData } from '@/utils'
  import * as action from '@/store/action-types'

  export default {
    name: 'starting-list',
    mixins: [templateMixin],
    data () {
      return {
        columnDefinitions: {
          'field': 'Bereich',
          'name': 'Name'
        }
      }
    },
    computed: {
      ...mapOverlayData({'records': {default: []}}),
      ...mapOverlayOptions({pageIntervalSecs: {default: 0}, itemsPerPage: {default: 8}}),
      ...mapTemplateData(['datasetId']),
      ...mapTemplateData({columnMap: {default: {}}}),
      records () {
        const dataset = this.$store.getters.dataset(this.datasetId)
        if (!dataset) return []
        const records = [].concat(dataset.records)
        records.sort((a, b) => {
          return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER)
        })
        return records.map(record => {
          return this.mapRecord(record, this.columnMap)
        })
      }
    },
    watch: {
      records: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {records: val}
        })
      }
    },
    methods: {
      mapRecord (record, columnMap) {
        return Object.keys(columnMap).reduce((result, key) => {
          result[key] = record[columnMap[key]]
          return result
        }, {})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/credits.vue